/**
 * assetLoadGate – when the player may put the lesson's 3D models in the scene.
 *
 * The loader only runs in a ready (or presenting) scene. It deliberately does not
 * re-run on every state change, because entering VR flips the state and a re-run
 * there duplicated every model. But the model list can arrive while the state is
 * still 'loading' — which is exactly what happens when a class moves to a new
 * launch and a student's player swaps content in place — and then nothing ever
 * retried. A skipped load is therefore remembered, and retried once the scene
 * becomes ready.
 */

export type PlayerLoadingState = 'loading' | 'ready' | 'error' | 'no-vr' | 'in-vr';

export function shouldLoadAssets(state: PlayerLoadingState, sceneReady: boolean): boolean {
  return sceneReady && (state === 'ready' || state === 'in-vr');
}

/** A retry is due when a load was skipped earlier and the scene can now take it. */
export function shouldRetryDeferredLoad(
  deferred: boolean,
  state: PlayerLoadingState,
  sceneReady: boolean
): boolean {
  return deferred && shouldLoadAssets(state, sceneReady);
}
